/**
 * Genera un delay aleatorio (jitter) para distribuir la carga de requests
 * Previene thundering herd al espaciar requests concurrentes
 *
 * @param maxMs - Delay máximo en milisegundos (default: 3000ms)
 * @returns Promise que se resuelve después del delay aleatorio en el rango [0, maxMs)
 *
 * @example
 * // Aplica jitter con default de 3000ms
 * await applyJitter()
 *
 * // Aplica jitter con valor personalizado
 * await applyJitter(2000)
 */
export const applyJitter = (maxMs: number = 3000): Promise<void> => {
    const delayMs = Math.floor(Math.random() * maxMs)
    return new Promise(resolve => setTimeout(resolve, delayMs))
}
